<template>
  <v-container fluid py-0>
    <v-container pt-0 class="home">
      <!-- home -->
      <v-row class="text-center">
        <v-col class="home-title">
          <h1
            class="text-h5 text-sm-h3 secondary--text font-weight-bold mb-10 mb-sm-15"
          >
            {{ $t('home_page_title') }}
          </h1>

          <p
            class="font-weight-medium mb-0 primary--text"
            style="font-size: 18px;"
          >
            {{ $t('home_page_subtitle') }}
          </p>
        </v-col>

        <v-col cols="12" class="mt-10 mt-sm-14">
          <v-btn
            outlined
            class="text-none text-body-2 text-wrap"
            id="home-btn"
            height="60"
            :to="`${$route.params.lang === 'en' ? 'en' : ''}/koordinatori`"
          >
            {{ $t('home_page_button2') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row
      class="justify-center"
      style="background-color: #E4E7EA; position: relative"
    >
      <v-col class="panels-section">
        <v-container class="edu-img">
          <v-img src="../../assets/Browser.png"></v-img>
        </v-container>

        <v-container id="main-panels">
          <v-expansion-panels accordion>
            <v-expansion-panel
              class="mb-6 mb-md-8 panel"
              v-for="(panel, index) in panelContent"
              :key="index"
            >
              <v-expansion-panel-header
                id="panel-header"
                class="text-none"
                disable-icon-rotate
              >
                <v-icon slot="actions" color="secondary"
                  >mdi-unfold-more-horizontal</v-icon
                >
                <v-avatar max-width="48" class="accent mr-5 mr-sm-10">
                  <v-icon color="white" size="28">{{ panel.icon }}</v-icon>
                </v-avatar>
                <span class="secondary--text">{{ $t(panel.title) }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                class="panel-content flex-column primary--text font-weight-medium"
                v-html="$t(panel.text)"
              ></v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-col>
    </v-row>

    <v-row style="height: 275px"></v-row>

    <v-row style="min-height: 160px; background-color: #F4F6F8;">
      <v-col cols="12" class="hidden-xs-only" style="z-index: 1">
        <v-container class="py-0" id="footer-stats">
          <v-row style="height: 100%">
            <v-col cols="10" class="pb-8 pt-6">
              <v-row class="justify-center">
                <img class="pr-6" src="../../assets/edu-logo-white.svg" />
                <div class="white--text d-flex flex-column">
                  <span class="font-weight-medium text-h5"
                    >{{ $t('footer_statistics') }}</span
                  >
                  <span style="font-size: 13px"
                    >{{ $t('footer_subheading') }} {{todayDate}}</span
                  >
                </div>
              </v-row>

              <v-row class="mt-8 white--text">
                <v-col v-for="(item, index) in stats.slice(0, -1)" :key="index">
                  <v-row class="justify-center pb-2">
                    <v-avatar size="64" color="accent">
                      <v-icon size="32" color="white">{{ item.icon }}</v-icon>
                    </v-avatar>
                  </v-row>
                  <v-row class="justify-center pb-2">
                    <h1 class="display-2 font-weight-light">
                      {{ item.data }}
                    </h1>
                  </v-row>
                  <v-row
                    class="justify-center font-weight-medium"
                    style="font-size: 13px"
                    >{{ $t(item.title) }}</v-row
                  >
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="2"
              class="d-flex align-center"
              style="background-color: rgba(255, 255, 255, 0.07);"
            >
              <v-row @click="$router.push('/koordinatori')" style="cursor: pointer;">
                <v-col cols="12" class="d-flex justify-center"
                  ><v-icon size="32" color="white"
                    >mdi-arrow-right</v-icon
                  ></v-col
                >
                <v-col
                  cols="12"
                  class="d-flex justify-center text-uppercase white--text font-weight-medium"
                  style="font-size: 13px"
                  >{{ $t('footer_more') }}</v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>

      <!-- footer-stats-mobile -->
      <v-col class="px-6 hidden-sm-and-up" style="z-index: 1">
        <v-container class="pa-0" id="footer-stats">
          <v-row style="height: 100%">
            <v-col class="py-4">
              <v-row class="justify-center flex-column">
                <img class="mb-4" src="../../assets/edu-logo-white.svg" />
                <div class="white--text d-flex flex-column text-center">
                  <span
                    class="font-weight-medium text-h5 mb-2"
                    style="padding: 0 75px"
                    >{{ $t('footer_statistics') }}</span
                  >
                  <span style="font-size: 12px;" class="px-6"
                    >{{ $t('footer_subheading') }} {{todayDate}}</span
                  >
                </div>
              </v-row>

              <v-carousel
                height="250px"
                cycle
                hide-delimiter-background
                :show-arrows="false"
              >
                <v-carousel-item v-for="(item, index) in stats" :key="index">
                  <v-row class="mt-8 white--text">
                    <v-col v-if="item.name != 'detalji'">
                      <v-row class="justify-center pb-2">
                        <v-avatar size="64" color="accent">
                          <v-icon size="32" color="white">{{
                            item.icon
                          }}</v-icon>
                        </v-avatar>
                      </v-row>
                      <v-row class="justify-center pb-2">
                        <h1 class="display-2 font-weight-light">
                          {{ item.data }}
                        </h1>
                      </v-row>
                      <v-row
                        class="justify-center font-weight-medium"
                        style="font-size: 13px"
                        >{{ $t(item.title) }}</v-row
                      >
                    </v-col>

                    <v-col
                      v-else
                      class="d-flex align-center"
                      style="background-color: rgba(255, 255, 255, 0.07);"
                    >
                      <v-row @click="$router.push('/koordinatori')" style="cursor: pointer;">
                        <v-col cols="12" class="d-flex justify-center"
                          ><v-icon size="32" color="white"
                            >mdi-arrow-right</v-icon
                          ></v-col
                        >
                        <v-col
                          cols="12"
                          class="d-flex justify-center text-uppercase white--text font-weight-medium"
                          style="font-size: 13px"
                          >{{$t('footer_more')}}</v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
  data: () => ({
    //
  }),
  computed: {
    todayDate() {
      const monthNames = ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj",
        "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"];
      let dateObj = new Date();
      let month = monthNames[dateObj.getMonth()];
      let day = String(dateObj.getDate()).padStart(1, '0');
      let year = dateObj.getFullYear();
      let output = `${day}. ${month} ${year}. godine`

      return output
    },
    panelContent() {
      return [
        {
          icon: "mdi-cloud-circle",
          title: "homepage_drop1_title",
          text: `homepage_drop1_content`
        },
        {
          icon: "mdi-account-lock",
          title: "homepage_drop2_title",
          text: `homepage_drop2_content`
        }
      ];
    },
    stats() {
      return [
        {
          name: "usluge",
          icon: "mdi-book-variant-multiple",
          data: "20",
          title: "footer_icon1"
        },
        {
          name: "identiteti",
          icon: "mdi-account-box-multiple",
          data: "-",
          title: "footer_icon2"
        },
        {
          name: "ustanove",
          icon: "mdi-domain",
          data: "146",
          title: "footer_icon3"
        },
        {
          name: "detalji",
          icon: "mdi-arrow-right",
          data: null,
          title: "footer_more"
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.home {
  height: 750px;
}

#home-btn {
  color: #448aff;
  border: 2px solid #448aff;
  font-weight: 600;
}

.home-title {
  margin-top: 96px;
}

#home-btn:hover {
  background-color: #448aff;
  color: white;
}

.panels-section {
  margin-top: -250px;
}

.edu-img {
  padding: 0px 150px !important;
}

.v-expansion-panel::before {
  box-shadow: 0px 20px 60px rgba(9, 14, 24, 0.1) !important;
}

.v-expansion-panel::after {
  border-top: none !important;
}

.panel {
  border-radius: 8px !important;
}

#main-panels {
  padding-top: 0px !important;
  padding-bottom: 140px !important;
  #panel-header {
    min-height: 100px;
    font-weight: 500;
    font-size: 32px;
    line-height: 39px;
    letter-spacing: -0.5px;
    padding: 12px 40px;
  }

  .panel-content {
    line-height: 26px;
    letter-spacing: 0.1px;
    div {
      padding: 60px;
      padding-left: 128px;
    }
    li {
      display: list-item;
      font-size: 16px;
    }
    ul {
      list-style-type: initial;
    }
  }
}

#footer-stats {
  background: #231f20;
  z-index: 30 !important;
  box-shadow: 0px 20px 60px rgba(9, 14, 24, 0.1);
  border-radius: 8px;
  min-height: 320px;
  margin-top: -160px;
  border-top: 12px solid #448aff;
}

.footer-info {
  padding: 56px 12px;
}

.icons a:not(:last-child) {
  margin-right: 10px;
}

@media only screen and (max-width: 1200px) {
  .home {
    height: 800px;
  }

  #main-panels {
    padding-bottom: 100px !important;
    #panel-header {
      font-size: 18px;
      padding: 12px 24px;
      line-height: 22px;
    }
    .panel-content div {
      padding: 40px;
      padding-left: 116px;
    }
  }

  .edu-img {
    padding: 0 !important;
  }

  .footer-info {
    padding: 16px 12px;
  }

  .icons .v-avatar,
  .fb-icon {
    height: 38px !important;
    width: 38px !important;
  }

  .icon {
    font-size: 22px !important;
  }

  .fb-icon {
    font-size: 43px !important;
  }
}

@media only screen and (max-width: 600px) {
  .home {
    height: 575px;
  }

  #home-btn .v-btn__content {
    max-width: 280px;
    height: 64px;
  }

  #home-btn {
    width: 100%;
  }

  #main-panels {
    padding-bottom: 45px !important;
    #panel-header {
      padding: 12px 16px;
    }
    .panel-content div {
      padding: 16px;
      padding-bottom: 28px;
    }
  }

  .home-title {
    margin-top: 40px;
  }

  .panels-section {
    margin-top: -150px;
  }

  #footer-stats {
    margin-top: -230px;
  }

  .v-carousel__controls {
    height: unset !important;
  }

  .v-carousel__controls .v-btn {
    margin: 0;
  }

  .v-carousel__controls__item .v-icon {
    font-size: 14px !important;
  }

  .v-carousel__controls__item.v-item--active .v-icon {
    opacity: 1 !important;
  }

  .v-carousel__controls .v-btn::before {
    opacity: 0 !important;
  }
}
</style>
